import React from 'react';
import classNames from 'classnames';
import StandardModal from 'components/consumer/StandardModal';
import CheckoutSubmitButton from '../../CheckoutSubmitButton';
import AddressSuggestionCard from './AddressSuggestionCard';

const AddressValidationModal = ({
  isOpen = false,
  onClose = () => {},
  shippingState,
  suggestion,
  handleSelectRecommended,
  handleKeepOriginal,
}) => (
  <StandardModal
    isOpen={isOpen}
    onClose={onClose}
    size="md"
    theme="light"
    showOkButtonOnMobile={false}
  >
    <div className="text-gray-dark flex flex-col text-center">
      <div className="text-center">
        <div className="text-gray-dark text-2xl">Address Recommendation</div>
        <div className="text-gray my-6">
          We are unable to confirm the address provided. You may use the address
          &ldquo;as is&rdquo;, but it may cause delivery delays.
        </div>
      </div>
      <div className="flex flex-col md:flex-row gap-4 justify-between">
        <AddressSuggestionCard
          title="Original Address:"
          key="shipping-modal-original-address-card"
        >
          <div>
            <div>{shippingState?.address}</div>
            <div>{shippingState?.city}</div>
            <div>{shippingState?.apartment}</div>
            <div>
              {shippingState?.state}
              {shippingState?.state && shippingState?.zipcode && ', '}
              {shippingState?.zipcode}
            </div>
          </div>
          <CheckoutSubmitButton
            dataXc="shipping-form-keep-original-address-button"
            onClick={handleKeepOriginal}
            id="shipping-form-keep-original-address-button"
            className="bg-gray-light4 !text-gray-dark mt-6"
          >
            Keep Original Address
          </CheckoutSubmitButton>
        </AddressSuggestionCard>
        <AddressSuggestionCard
          title="Recommended Address:"
          key="shipping-modal-recommended-address-card"
        >
          {suggestion ? (
            <div>
              <div
                className={classNames({
                  'text-red-dark':
                    suggestion?.address &&
                    suggestion?.address !== shippingState?.address,
                })}
              >
                {suggestion?.address || shippingState?.address || ''}
              </div>
              <div
                className={classNames({
                  'text-red-dark':
                    suggestion?.city &&
                    suggestion?.city !== shippingState?.city,
                })}
              >
                {suggestion?.city || shippingState?.city || ''}
              </div>
              <div
                className={classNames({
                  'text-red-dark':
                    suggestion?.apartment &&
                    suggestion?.apartment !== shippingState?.apartment,
                })}
              >
                {suggestion?.apartment || shippingState?.apartment || ''}
              </div>
              <div>
                <span
                  className={classNames({
                    'text-red-dark':
                      suggestion?.state &&
                      suggestion?.state !== shippingState?.state,
                  })}
                >
                  {suggestion?.state || shippingState?.state || ''}
                  {', '}
                </span>
                <span
                  className={classNames({
                    'text-red-dark':
                      suggestion?.zipcode &&
                      suggestion?.zipcode !== shippingState?.zipcode,
                  })}
                >
                  {suggestion?.zipcode || shippingState?.zipcode || ''}
                </span>
              </div>
            </div>
          ) : (
            <div>Unknown Address</div>
          )}
          <CheckoutSubmitButton
            dataXc="shipping-form-select-recommended-address-button"
            onClick={handleSelectRecommended}
            id="shipping-form-select-recommended-address-button"
            className="!bg-brand mt-6"
            disabled={!suggestion}
          >
            Select Recommended Address
          </CheckoutSubmitButton>
        </AddressSuggestionCard>
      </div>
      <div className="text-2xl my-6">or</div>
      <div className="flex justify-center">
        <CheckoutSubmitButton
          dataXc="shipping-form-edit-original-address-button"
          onClick={onClose}
          id="shipping-form-edit-original-address-button"
          className="max-w-full md:max-w-[50%]"
        >
          Edit Original Address
        </CheckoutSubmitButton>
      </div>
    </div>
  </StandardModal>
);

export default AddressValidationModal;
